import { useTheme } from '@mui/material/styles';
import { Text, TextProps } from 'components/Text';

interface Props extends TextProps {
  crossed?: boolean;
}
export const BoldLabel = ({ crossed, sx, ...rest }: Props) => {
  const theme = useTheme();

  return (
    <Text
      sx={{
        fontWeight: 600,
        pb: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('sm')]: {
          fontSize: 15
        },
        textDecoration: crossed ? 'line-through' : 'none',
        ...sx
      }}
      {...rest}
    />
  );
};
